import React from 'react';
import { BadgePercent, ShieldCheck } from 'lucide-react';
import { rupees } from '@/lib/shop';

/** Price details card used by cart and checkout. `summary` is the API's cart/preview summary. */
const PriceSummary = ({ summary, groups = [], children, title = 'Price details' }) => {
  if (!summary) return null;
  const save = Number(summary.discountOnMrp || 0);
  return (
    <div className="lk-card overflow-hidden">
      <h2 className="border-b border-ink-200/70 px-5 py-3.5 text-xs font-bold uppercase tracking-wide text-ink-500">{title}</h2>
      <dl className="tabular space-y-3 px-5 py-4 text-sm">
        <div className="flex justify-between">
          <dt className="text-ink-700">
            Price ({summary.itemCount} item{summary.itemCount === 1 ? '' : 's'})
          </dt>
          <dd className="text-ink-900">{rupees(summary.totalMrp)}</dd>
        </div>
        {summary.discountOnMrp > 0 && (
          <div className="flex justify-between">
            <dt className="text-ink-700">Discount on MRP</dt>
            <dd className="text-success">− {rupees(summary.discountOnMrp)}</dd>
          </div>
        )}
        <div className="flex justify-between">
          <dt className="text-ink-700">
            Delivery
            {groups.length > 1 && <span className="block text-xs text-ink-500">{groups.length} stores ship separately</span>}
          </dt>
          <dd className={summary.deliveryFee ? 'text-ink-900' : 'font-semibold text-success'}>
            {summary.deliveryFee ? rupees(summary.deliveryFee) : 'Free'}
          </dd>
        </div>
        <div className="flex justify-between border-t border-dashed border-ink-200 pt-3 text-base font-bold text-ink-900">
          <dt>Total amount</dt>
          <dd>{rupees(summary.total)}</dd>
        </div>
      </dl>
      {save > 0 && (
        <p className="mx-5 mb-4 flex items-center gap-2 rounded-xl bg-success-tint px-3 py-2 text-sm font-semibold text-success">
          <BadgePercent className="h-4 w-4 shrink-0" />
          You save {rupees(save)} on this order
        </p>
      )}
      {children}
      <p className="flex items-center gap-2 border-t border-ink-200/70 bg-surface-muted px-5 py-3 text-xs text-ink-500">
        <ShieldCheck className="h-4 w-4 shrink-0" />
        Safe and secure payments. Prices include GST.
      </p>
    </div>
  );
};

export default PriceSummary;
